import { loadStripe, type Stripe } from '@stripe/stripe-js';
import { API_BASE } from '@/lib/config';

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    stripePromise = fetch(`${API_BASE}/billing/config`)
      .then((r) => r.json())
      .then((data: { publishableKey: string }) => loadStripe(data.publishableKey));
  }
  return stripePromise;
}
